import React from 'react';
import { Link } from 'react-router-dom';
import { StatusBadge } from './PocUi';
import { formatAmount, formatTimestamp, manufacturerName, modelLabel } from './pocFormat';

/** POC claim rows (list items from /poc-claims or the summary's recent claims). */
export default function ClaimTable({ items, manufacturers, caption }) {
    return (
        <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
                <caption className="sr-only">{caption}</caption>
                <thead>
                    <tr className="text-left text-[10px] uppercase tracking-widest text-text-muted">
                        <th scope="col" className="py-2 pr-4 font-semibold">Claim ID</th>
                        <th scope="col" className="py-2 pr-4 font-semibold">Manufacturer</th>
                        <th scope="col" className="py-2 pr-4 font-semibold">Model</th>
                        <th scope="col" className="py-2 pr-4 font-semibold">Component</th>
                        <th scope="col" className="py-2 pr-4 font-semibold">Repair Date</th>
                        <th scope="col" className="py-2 pr-4 font-semibold text-right">Claim Amount</th>
                        <th scope="col" className="py-2 pr-4 font-semibold">Current Decision</th>
                        <th scope="col" className="py-2 pr-4 font-semibold">Submitted</th>
                        <th scope="col" className="py-2 font-semibold"><span className="sr-only">Actions</span></th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => (
                        <tr key={item.claim_id} className="border-t border-line">
                            <td className="py-2 pr-4 font-semibold whitespace-nowrap">{item.claim_id}</td>
                            <td className="py-2 pr-4">{manufacturerName(manufacturers, item.manufacturer_code)}</td>
                            <td className="py-2 pr-4">
                                {modelLabel(item)}
                                {item.model_year && <span className="block text-[11px] text-text-muted">Model year {item.model_year}</span>}
                            </td>
                            <td className="py-2 pr-4">{item.component_category || '—'}</td>
                            <td className="py-2 pr-4 whitespace-nowrap">{item.repair_date || '—'}</td>
                            <td className="py-2 pr-4 text-right whitespace-nowrap">{formatAmount(item.claim_amount, item.currency)}</td>
                            <td className="py-2 pr-4"><StatusBadge status={item.claim_status} /></td>
                            <td className="py-2 pr-4 whitespace-nowrap text-text-muted">{formatTimestamp(item.created_at)}</td>
                            <td className="py-2">
                                <Link to={`/poc-claims/${item.claim_id}`} className="text-xs font-semibold uppercase tracking-widest underline underline-offset-2"
                                      aria-label={`View details for ${item.claim_id}`}>
                                    View
                                </Link>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
